import React,{useContext,useState,useEffect} from 'react'


const API = 'https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=9e6cb54fb7368ab503a406230cc63f3a&page=1';
const SEARCHAPI ="https://api.themoviedb.org/3/search/movie?&api_key=9e6cb54fb7368ab503a406230cc63f3a&query=";

const Appcontext = React.createContext()
const Context = ({children}) => {
    const [search,setSearch] = React.useState('')
    const [movies,setMovies] = useState([])
    const searchValue = React.useRef(null)

    const fetchMovie =  async(api) =>{
        const resp = await fetch(api)
        const data = await resp.json()
        // console.log(data.results);
        setMovies(data.results)
    }

    useEffect(()=>{
        if(search){
            fetchMovie(SEARCHAPI+search)
        }else{
            fetchMovie(API)
        }
    },[search])
    // console.log(movies);

    useEffect(()=>{
        fetchMovie(API)
    },[])

    return (
        <Appcontext.Provider value={{setSearch,search,searchValue,setMovies,movies,fetchMovie}}>
            {children}
        </Appcontext.Provider>
    )
}

export const useGlobalContext = () =>{
    return useContext(Appcontext)
}

export {Appcontext,Context}
